import styled from 'styled-components';

const Wrapper = styled.div`
  height: calc(100% - 95px);
  text-align: center;
  position: relative;
`;

export default Wrapper;
